import { compareVersions } from './version';

export const MIN_ACCOUNT_FEATURE_VERSION = '1.0.5';

export function isDevClientPreview(runtimeInfo) {
    return process.env.NODE_ENV !== 'production'
        && runtimeInfo?.isDev === true
        && Boolean(window.IS_NATIVE_APP || window.ReactNativeWebView);
}

export function areRelease105FeaturesAvailable(runtimeInfo) {
    const isNativeApp = Boolean(window.IS_NATIVE_APP || window.ReactNativeWebView);
    const nativeVersion = runtimeInfo?.appVersion || runtimeInfo?.runtimeVersion || '';
    return Boolean(isNativeApp && nativeVersion && compareVersions(nativeVersion, MIN_ACCOUNT_FEATURE_VERSION) >= 0);
}

export function supportsAccountFeatures(runtimeInfo) {
    return areRelease105FeaturesAvailable(runtimeInfo);
}

export function supportsAccountLogin(runtimeInfo) {
    return supportsAccountFeatures(runtimeInfo) && runtimeInfo?.capabilities?.accountLogin === true;
}
